"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
import SvgSpriteConsumer from "../SvgSprite/SvgSpriteConsumer";
import { InputVariant } from "./Input.types";
const FieldRightElement = ({ rightElement, variant, disabled, }) => {
    switch (variant) {
        case InputVariant.ERROR:
            return (_jsx(Box, Object.assign({ h: "6", w: "6", color: "semantic.icon.error" }, { children: _jsx(SvgSpriteConsumer, { svgId: "alert24", size: 24 }) })));
        case InputVariant.SUCCESS:
            return (_jsx(Box, Object.assign({ h: "6", w: "6", color: "semantic.icon.success" }, { children: _jsx(SvgSpriteConsumer, { svgId: "checkCircle24", size: 24 }) })));
        default: {
            return rightElement ? (_jsx(Box, Object.assign({ h: "6", w: "6", color: disabled ? "semantic.icon.disabled" : "semantic.interactive.primary" }, { children: rightElement }))) : null;
        }
    }
};
export default FieldRightElement;
//# sourceMappingURL=FieldRightElement.js.map